module.exports = __webpack_public_path__ + "assets/img/content.d98c8569.jpg";